import { render } from "./UpdateTime.vue?vue&type=template&id=27b8336a"
import script from "./UpdateTime.vue?vue&type=script&lang=ts"
export * from "./UpdateTime.vue?vue&type=script&lang=ts"

import "./UpdateTime.vue?vue&type=style&index=0&id=27b8336a&lang=css"
script.render = render

export default script